// istanbul ignore file
import { BuildHtml, BuildHtmlProps } from "~/components/BuildHtml";
import { landingPageTagToClassNameMap } from "~/components/LandingPageV2/landingPageTagToClassNameMap";
import { landingPageTagToReactConverters } from "~/components/LandingPageV2/landingPageTagToReactConverters";

export const LandingPageBuildHtml: React.FC<Pick<BuildHtmlProps, "html">> = ({
  html,
}) => (
  <BuildHtml
    html={html}
    tagToClassNameMap={landingPageTagToClassNameMap}
    tagToReactConverters={landingPageTagToReactConverters}
  />
);
